export function geoMbox() {
  if (typeof window !== 'undefined' && window.adobe && window.adobe.target) {
    const el: any = document.getElementById('geo_mbox');
    window.adobe.target.getOffer({
      mbox: 'EXP_lw_listings',
      success: function (offer: any) {
        window.adobe.target.applyOffer({
          mbox: 'EXP_lw_listings',
          selector: el,
          offer: offer
        });
      },
      error: function () {
        el.style.visibility = 'visible';
      }
    });
  }
}
export function globalMbox() {
  if (typeof window !== 'undefined' && window.adobe && window.adobe.target) {
    const el: any = document.getElementById('global_public_mbox');
    window.adobe.target.getOffer({
      mbox: 'EXP_Global_Public_Framework',
      success: function (offer: any) {
        window.adobe.target.applyOffer({
          mbox: 'EXP_Global_Public_Framework',
          selector: el,
          offer: offer
        });
      },
      error: function () {
        el.style.visibility = 'visible';
      }
    });
  }
}
